import React from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import { validateSpouseName, isPersonalInfoValid } from '../PersonalInfoWorkflowValidator';
import Input, { CENTER } from '../../Input/InputView';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import partnerNameShouldSkip from './PartnerNameShouldSkip';

const PartnerName = ({
  branch,
  workflowId,
  clientId,
  partnerName,
  store,
  optionIsMarried,
  personalInfo,
  isGoingForward,
  dirtyGraphNodes,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    id="PartnerName"
    canSkip={partnerNameShouldSkip(isGoingForward, optionIsMarried, personalInfo, partnerName)}
  >
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.PartnerName`} />
    <AdvForm>
      <h2>What is your partner&apos;s first name?</h2>
      <ul className="horizontal">
        <li>
          <Input
            type="text"
            isUnder
            maxLength="256"
            id="first-name"
            placeholder="First Name"
            alignment={CENTER}
            className="md text-center"
            value={partnerName}
            onChange={inputTextChanged(
              clientId,
              store(workflowId),
              `${BACKEND_KEY}.Partner.FirstName`,
            )}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={dirtyGraphNodes}
      validator={validateSpouseName(personalInfo, partnerName)}
      validationId={`${BACKEND_KEY}.PartnerName`}
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      doNotSave={!isPersonalInfoValid(optionIsMarried, personalInfo)}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'partner_info_completed')}
    />
  </AdvWorkflowStep>
);

PartnerName.defaultProps = {
  partnerName: '',
  optionIsMarried: false,
};

PartnerName.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  partnerName: PropTypes.string,
  optionIsMarried: PropTypes.bool,
  personalInfo: PropTypes.shape({}).isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  dirtyGraphNodes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default PartnerName;
